import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { PipeModule } from 'src/shared/pipes/pipe.module';
import { PaymentStudentComponent } from './payment-student.component';
import { PaymentManualLogsTableComponent } from 'src/shared/modules/payment-manual-logs-table/payment-manual-logs-table.component';



@NgModule({
  declarations: [PaymentStudentComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolProgramModule,
    SelectSchoolProgramCategoryModule,
    SelectSchoolActivityModule,
    SelectSchoolLevelRelationV2Module,
    MatTableModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatOptionModule,
    PipeModule,
    MatProgressSpinnerModule,
    PaymentManualLogsTableComponent
  ],
  exports: [PaymentStudentComponent]
})
export class PaymentStudentModule { }
